module.exports = __webpack_public_path__ + "static/media/jerry.32cfed9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/jerry.jpg
// module id = 713
// module chunks = 0